import http from "../../services/http";
import { MessageResultState } from "../../types/general-types";

/**
 * Sistemde tanımlı yetki anahtarları (SecYetki + harici kullanıcılara atanmışlar).
 * Liste yaklaşık 2200 kısa dizgi, ~45 KB: tek istekte alınıp istemcide filtrelenir.
 * Sonuç modül ömrü boyunca önbelleklenir, katalog oturum içinde değişmiyor.
 */
let cache: Promise<string[]> | null = null;

export function getPermissionKeys(): Promise<string[]> {
  if (cache) return cache;

  cache = http
    .get("/sso-external-user/permission-keys")
    .then((response) =>
      response?.data?.state === MessageResultState.SUCCESS
        ? (response.data.result as string[]) || []
        : []
    )
    .catch(() => [])
    .then((keys) => {
      if (keys.length === 0) cache = null;
      return keys;
    });

  return cache;
}
